var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
export var BaseInput = forwardRef(function (_a, ref) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, hasError = _a.hasError, props = __rest(_a, ["className", "hasError"]);
    return (_jsx("input", __assign({ ref: ref, className: "focus:!border-2 disabled:!cursor-not-allowed disabled:!opacity-50 !shadow-none\n        ".concat(hasError ? '!border-vjwDanger focus:!border-vjwDanger' : '!border-gray-300 focus:!border-vjwPrimary', " \n        ").concat(className) }, props)));
});
BaseInput.displayName = 'BaseInput';
